import { Validators } from '@angular/forms';

export interface EmailModel {
  firstName: string;
  emails: string;
  guid: string;
}


export class Email {
  public formBindings: EmailModel;
  constructor(
    public data?: EmailModel,
  ) { }

  /**
  * @method __defaults Return the defaults values for the model
  * @returns All the values in the EmailModel interface as ''
  **/
  public __defaults(): EmailModel {
    return this.formBindings = {
      firstName: '',
      emails: '',
      guid: ''
    };
  }
  /**
  * @method values Return the values send in the data property
  * @returns SignUpModel Interface
  **/
  public get values(): EmailModel {
    return this.data !== undefined ? this.__formBindings({ ...this.data }) : this.__defaults();
  }
  /**
  * @method __formBindings Returns the values for initialize in case of read mode
  * @returns SignUpModel
  **/
  public __formBindings(bindings: EmailModel): EmailModel {
    return {
      'firstName': bindings['firstName'] ? bindings['firstName'] : '',
      'emails': bindings['emails'] ? bindings['emails'] : '',
      'guid': bindings['guid'] ? bindings['guid'] : ''
    };
  }

  /**
  * @method form Return the form controls to be used in the update-account component
  * @returns Object with the controls
  **/
  public get form(): object {
    return this.customerControls;
  }
  /**
  * @method customerControls Controls for the admin view
  * @returns Object with the required controls
  **/
  public get customerControls(): object {
    return {
      firstName: this.firstNameControl,
      emails: this.emailControl,
      guid: this.guidControl
    };
  }
  /**
  * @method emailControl Controls for email field
  * @returns Array of validators
  **/
  public get emailControl(): any[] {
    return [
      { value: '', disabled: true }
    ];
  }
  /**
  * @method firstNameControl Controls for first name field
  * @returns Array of validators
  **/
  public get firstNameControl(): any[] {
    return [
      { value: '', disabled: true },
    ];
  }
    /**
  * @method guidControl Controls for guid field
  * @returns Array of validators
  **/
  public get guidControl(): any[] {
    return [
      { value: '', disabled: true }
    ];
  }

}

